import {
  NotificationPreferencesDto,
  NotificationPreferenceSubcategory,
} from "../hooks";
import { NotificationPreferenceFormItem } from "./notification-preference-form-item";
import {
  Box,
  Stack,
  StackDivider,
  Switch,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";

export interface NotificationPreferenceSubcategoryFormProps
  extends NotificationPreferenceSubcategory {
  category: keyof NotificationPreferencesDto;
  handleChange: (
    category: keyof NotificationPreferencesDto,
    subcategory: string,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
}

export const NotificationPreferenceSubcategoryForm = ({
  title,
  description,
  topic,
  category,
  preferences,
  handleChange,
}: NotificationPreferenceSubcategoryFormProps) => {
  return (
    <Box as="section" py={{ base: "4", md: "8" }}>
      <Box
        bg="bg-surface"
        boxShadow={useColorModeValue("sm", "sm-dark")}
        borderRadius="lg"
        p={{ base: "4", md: "6" }}
      >
        <Stack spacing="5" divider={<StackDivider />}>
          <Stack justifyContent="space-between" flexDirection="row">
            <Stack spacing="1">
              <Text fontSize="lg" fontWeight="medium">
                {title}
              </Text>
              <Text fontSize="sm" color="muted">
                {description}
              </Text>
            </Stack>
            <Switch
              id={title}
              isChecked={preferences.every((preference) => preference.value)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                preferences.forEach((preference) =>
                  handleChange(category, topic, {
                    ...e,
                    target: {
                      ...e.target,
                      name: preference.name,
                    },
                  }),
                )
              }
              name={title}
              colorScheme="green"
            />
          </Stack>
          {preferences.map((preference, id) => (
            <NotificationPreferenceFormItem
              key={`${category}-${topic}-${id}`}
              id={`${category}-${topic}-${id}`}
              title={preference.title}
              description={preference.description}
              isActive={preference.value}
              name={preference.name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange(category, topic, e)
              }
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
};
